/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { ON_PROGRESS_DATA, LOADER_STATUS } from './constants';

// The initial state of the App
export const initialState = {
  progressData: '',
  loaderStatus: false
};

/* eslint-disable default-case, no-param-reassign */
const progressReducer = (state = initialState, action) =>{
    switch (action.type) {
      case ON_PROGRESS_DATA:
        return {
          ...state,
          progressData:action.progressData
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      default:
        return state;
      
    }
  };

export default progressReducer;
